import axios from 'axios';

const BankStatementTransactionService = {
  async updateBankStatementTransaction({ formValues, id }) {
    const response = await axios.patch(
      `/bank-statement-transactions/${id}`,
      formValues
    );

    return response.data;
  },

  async deleteBankStatementTransaction(id) {
    const response = await axios.delete(`/bank-statement-transactions/${id}`);

    return response.data;
  },
};

export default BankStatementTransactionService;
